import React from 'react';
import { Section } from './ui/Section';
export const ProblemSection = () => {
  const tableData = [{
    probaste: 'Meditación',
    porQue: 'Tu cabeza siguió pensando igual y encima te frustraste'
  }, {
    probaste: 'Pastillas para dormir',
    porQue: 'Te dormiste esa noche pero el problema volvió'
  }, {
    probaste: 'Infusiones y suplementos',
    porQue: 'Ayudan un poco pero no atacan la causa real'
  }, {
    probaste: 'Música y sonidos',
    porQue: 'Distracción temporal. Cuando para, el pensamiento vuelve'
  }, {
    probaste: 'Contar ovejas',
    porQue: 'Tu cerebro lo aburre en 30 segundos y vuelve al espiral'
  }, {
    probaste: 'Fuerza de voluntad',
    porQue: 'Intentar no pensar hace que pienses más'
  }];
  return <Section data-id="element-294">
      <div className="max-w-3xl mx-auto" data-id="element-295">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-white text-center md:text-left" data-id="element-296">
          Por qué no podés dormir aunque estés agotado
        </h2>

        <div className="space-y-6 text-lg text-gray-300 mb-16" data-id="element-297">
          <p className="text-xl" data-id="element-298">
            La mayoría cree que no puede dormir porque es ansiosa.{' '}
            <span className="text-white font-bold" data-id="element-299">Eso no es verdad.</span>
          </p>

          <div className="bg-night-800 border border-cta/30 p-8 rounded-2xl my-10 shadow-lg relative overflow-hidden" data-id="element-300">
            <div className="absolute -right-10 -top-10 w-32 h-32 bg-cta/20 rounded-full blur-3xl" data-id="element-301" />
            <p className="text-2xl md:text-3xl text-white font-bold text-center relative z-10 leading-tight" data-id="element-302">
              Tu cerebro no recibió la señal de que el día terminó.
            </p>
          </div>

          <div className="space-y-4" data-id="element-303">
            <p data-id="element-304">
              Tu cerebro estuvo todo el día en modo activo. Resolviendo,
              procesando, anticipando.
            </p>
            <p data-id="element-305">
              Y cuando te acostás, nadie lo apagó. Nadie le avisó que el día
              terminó.
            </p>
            <p data-id="element-306">
              Entonces sigue buscando cosas que resolver mientras vos estás ahí,
              con los ojos cerrados.
            </p>
          </div>
        </div>

        <div className="overflow-x-auto pb-4 mb-8" data-id="element-307">
          <table className="w-full text-left border-collapse min-w-[500px]" data-id="element-308">
            <thead data-id="element-309">
              <tr className="border-b-2 border-night-700" data-id="element-310">
                <th className="py-4 px-6 text-white font-bold bg-night-800 rounded-tl-lg w-1/3" data-id="element-311">
                  Lo que probaste
                </th>
                <th className="py-4 px-6 text-white font-bold bg-night-800 rounded-tr-lg" data-id="element-312">
                  Por qué no funcionó
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700" data-id="element-313">
              {tableData.map((row, idx) => <tr key={idx} className="hover:bg-night-800/50 transition-colors" data-id="element-314">
                  <td className="py-4 px-6 font-medium text-gray-200" data-id="element-315">
                    {row.probaste}
                  </td>
                  <td className="py-4 px-6 text-gray-400" data-id="element-316">{row.porQue}</td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-10" data-id="element-317">
          <p className="text-xl md:text-2xl text-white font-bold inline-block border-b-2 border-accent-blue pb-2" data-id="element-318">
            Ninguna de esas cosas ataca el problema real.
          </p>
        </div>
      </div>
    </Section>;
};